import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class TokenUserInfo extends AdornisEntity {
  public static override _class = 'TokenUserInfo';
  @Field(type => String)
  public fullName!: string;

  @Field(type => String)
  public birthDay!: string;

  @Field(type => String)
  public examDurationInfo!: string;

  @Field(type => String)
  public shortToken!: string;
}
